<template>
  <b-container>

    <div class="vdist">
      <Progress v-if="progress!==null" :done="progress.done" :todo="progress.todo" :rest="null" ></Progress>
    </div>

    <div v-if="votePairs.length>0">
      <div v-for="(vp,i) in votePairs" :key="vp.vote.id">
        <Vote v-if="i===0"
              :vote-pair="vp"
              @voteComplete="voteCompleted"></Vote>
      </div>
    </div>
    <h3 v-if="votePairs.length===0">Wydaje się, że na razie to wszystko. </h3>

  </b-container>
</template>

<script>

import {api} from '@/utils'
import Vote from "@/components/Vote";
import Progress from "@/components/Progress";

export default {
  name: 'votePage',
  components: {Progress, Vote},
  props: ["axios"],
  data: function () {
    return {
      votePairs: [],
      progress: null,
    }
  },
  created() {
    this.loadAndQueueItems();
    this.loadProgress();
  },
  methods: {
    loadAndQueueItems() {
      this.axios.get(api("pairs/next"))
          .then(resp => {
            let inQueue = new Set()
            for (let vp of this.votePairs)
              inQueue.add(vp.id)
            for (let vp of resp.data) {
              if (!inQueue.has(vp.id)) {
                inQueue.add(vp.id)
                this.votePairs.push(vp)
              }
            }
          })
    },
    loadProgress() {
      this.axios.get(api("progress"))
          .then(resp => this.progress = resp.data.progress)
    },
    voteCompleted(vp) {
      this.axios.post(api("vote"), vp)
          .then(() => {
            this.votePairs.splice(0, 1)
            this.loadAndQueueItems()
            this.loadProgress()
          })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
